<div class="code-content scroll-content w-100" :class="className" style="max-height: 150px;">{{ getModel }}</div>